<template>
  <div class="offers-table">
    <offers-card
      v-for="item in response"
      :item="item"
      :key="item.id"
      :category="getCategory(item.category)"
    ></offers-card>

    <app-table-dropdown
      v-if="showTable"
      route="/offers/item/"
      :isHeaderLink="false"
      :response="response"
      :isAllClose="isAllClose"
    >
      <template #row-header="{ item }">
        <div class="app-table-dropdown__row-header-default">
          <div
            class="app-table-dropdown__row-header-default-item offers-table__row-header-item offers-table__row-header-item--center"
          >
            <template v-if="item.shippingOptions && !responsive.isSm">
              <i
                v-for="shipping in item.shippingOptions"
                :key="shipping"
                class="offers-table__delivery-icon"
                :class="getIconDelivery(shipping)"
                :title="shipping | shipping"
              />
            </template>
            <div class="offers-table__name-offer">
              <span class="text-ellipsis">{{ item.name }}</span>
              <span v-if="responsive.isMd" class="text-ellipsis">{{
                getCategory(item.category)
              }}</span>
            </div>
            <template v-if="responsive.isSm">
              <div class="text-ellipsis">
                {{ item.warehouse ? item.warehouse.name : '' }}
              </div>
              <div class="offers-table__row-header-delivery">
                <template v-if="item.shippingOptions">
                  <i
                    v-for="shipping in item.shippingOptions"
                    :key="shipping"
                    class="offers-table__delivery-icon"
                    :class="getIconDelivery(shipping)"
                    :title="shipping | shipping"
                  />
                </template>
              </div>
            </template>
          </div>
          <div
            v-if="!responsive.isMd"
            class="app-table-dropdown__row-header-default-item offers-table__row-header-item"
          >
            <span class="text-ellipsis">{{ getCategory(item.category) }}</span>
          </div>
          <div
            v-if="!responsive.isSm"
            class="app-table-dropdown__row-header-default-item"
          >
            {{ item.warehouse ? item.warehouse.name : '' }}
          </div>
          <div
            v-if="!responsive.isSm"
            class="app-table-dropdown__row-header-default-item app-table-dropdown__light offers-table__region-col"
          >
            {{ item.warehouse.region | firstWords() }}
          </div>
          <div
            v-if="!responsive.isSm"
            class="app-table-dropdown__row-header-default-item app-table-dropdown__light offers-table__density-col"
          >
            {{ item.density.toFixed(3) || 'н/д' }} г / см3
          </div>
          <div
            class="app-table-dropdown__row-header-default-item app-table-dropdown__row-header-default-item--self-top offers-table__price-col"
          >
            <div>{{ item.pricePerTonne || 'н/д' | price() }} руб. / т</div>
            <div class="app-table-dropdown__light">
              {{ item.pricePerLiter || 'н/д' }} руб. / л
            </div>
            <div v-if="responsive.isSm">
              <span :class="getClassChangePrice(item.priceChangePerTonne)">{{
                item.priceChangePerTonne
              }}</span>
            </div>
          </div>
          <div
            v-if="!responsive.isSm"
            class="app-table-dropdown__row-header-default-item app-table-dropdown__light offers-table__change-col"
          >
            <span :class="getClassChangePrice(item.priceChangePerTonne)">{{
              item.priceChangePerTonne
            }}</span>
          </div>
          <div
            v-if="!responsive.isSm"
            class="app-table-dropdown__row-header-default-item app-table-dropdown__light offers-table__change-col"
          >
            <app-button-control
              isBlock
              class="offers-table__btn-buy"
              type="secondary"
              :to="`/offers/item/${item.id}`"
              @click="goToDetails(item.id)"
            >
              Купить
            </app-button-control>
          </div>
        </div>
      </template>

      <template #row-body="{ item, isShow }">
        <offers-table-item
          :response="item"
          :categories="categories"
          :isShow="isShow"
          class="offers-table__row-body"
        ></offers-table-item>
      </template>

      <template #portal="{ item, isShow }">
        <offers-table-portal
          :categories="categories"
          :response="item"
          :isShow="isShow"
        ></offers-table-portal>
      </template>
    </app-table-dropdown>
  </div>
</template>

<script>
import { ordersMapper } from '@/store/orders';
import { offersMapper } from '@/store/offers';
import { rootMapper } from '@/store/root';
import sortBy from 'lodash/sortBy';
import { getClassChangePrice, changeSort } from '@/helpers/index';
import { SELLER_TRACK } from '@/helpers/enums/delivery';

export default {
  name: 'OffersTable',
  inject: ['responsive'],
  components: {
    OffersCard: () => import('@/pages/offers/component/offersTable/OffersCard'),
    AppTableDropdown: () => import('@/components/common/AppTableDropdown'),
    AppButtonControl: () => import('@/components/ui/AppButtonControl'),
    OffersTableItem: () =>
      import('@/pages/offers/component/offersTable/OffersTableItem'),
    OffersTablePortal: () =>
      import('@/pages/offers/component/offersTable/OffersTablePortal'),
  },
  props: {
    response: {
      type: Array,
      required: true,
    },
    category: {
      type: String,
      default: 'н/д',
    },
    categories: {
      type: Array,
      default() {
        return [];
      },
    },
    isAllClose: {
      type: Boolean,
    },
    sort: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    showTable: false,
  }),
  computed: {
    ...offersMapper.mapState(['filterData']),
    ...rootMapper.mapState(['userCoords']),
    ...rootMapper.mapState(['userSaveAddressCoords']),
    sortedResponse() {
      return sortBy(this.response, [
        function sortByName(o) {
          return o.warehouse.name;
        },
      ]);
    },
  },
  watch: {
    // userCoords: {
    //   immediate: true,
    //   handler(value) {
    //     if (!value) {
    //       return;
    //     }

    //     const promises = [];

    //     this.response.forEach((offer) => {
    //       promises.push(this.getDeliveryPrice(offer, value.join()));
    //     });

    //     Promise.allSettled(promises).then((results) => {
    //       results.forEach((result) => {
    //         if (result.status === 'fulfilled') {
    //           this.SET_OFFERS_LIST_DELIVERY(result.value);
    //         }
    //       });
    //     });
    //   },
    // },
    userSaveAddressCoords: {
      handler(value) {
        const promises = [];

        this.response.forEach((offer) => {
          if (offer.priceType === 'perPiece') {
            return;
          }

          promises.push(this.getDeliveryPrice(offer, value));
        });

        Promise.allSettled(promises).then((results) => {
          results.forEach((result) => {
            if (result.status === 'fulfilled') {
              this.SET_OFFERS_LIST_DELIVERY(result.value);
            }
          });
        });
      },
    },
  },
  methods: {
    ...offersMapper.mapMutations(['SET_OFFERS_LIST_DELIVERY']),
    ...ordersMapper.mapActions(['deliveryPrice']),
    changeSort,
    getClassChangePrice,
    deliveryPriceData(item, coords) {
      return {
        offerId: item.id,
        location: coords,
        volume: this.filterData.volume,
        unit: this.filterData.unit,
        useLocalProductId: true,
      };
    },
    /**
     * Расчет стоимости доставки
     */
    async getDeliveryPrice(item, coords) {
      const sellerTruck = item.shippingOptions.some((el) =>
        SELLER_TRACK.includes(el)
      );

      if (!sellerTruck) {
        return {};
      }
      // eslint-disable-next-line @typescript-eslint/no-misused-promises, no-shadow
      return new Promise((resolve, reject) => {
        this.deliveryPrice(this.deliveryPriceData(item, coords))
          .then(({ price, distance, pricePerTonne }) => {
            resolve({
              id: item.id,
              ...{ price, distance, pricePerTonne },
            });
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    /**
     * Имя иконки в зависимости от типа доставки
     * @param {String} delivery - вид доставки
     */
    getIconDelivery(delivery) {
      if (delivery === 'autoDelivery') {
        return 'offers-table__delivery-icon--delivery';
      }
      if (delivery === 'autoSelf') {
        return 'offers-table__delivery-icon--self';
      }
      return '';
    },
    /**
     * Поиск категории
     * @param {Number} id
     */
    getCategory(id) {
      const category = this.categories.find((el) => el.uuid === id);
      if (category) {
        return category.name;
      }
      return '';
    },
    /**
     * Поереход в детальную страницу
     * @param {Number} id
     */
    goToDetails(id) {
      this.$router.push(`/offers/item/${id}`);
    },
  },
};
</script>
<style lang="scss">
.offers-table {
  &__name-offer {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  &__delivery-icon {
    @include size(24px);

    display: inline-block;
    flex-shrink: 0;
    margin-right: 10px;

    &--delivery {
      background-image: get-icon('Auto_Delivery_v3_24');
    }

    &--self {
      background-image: get-icon('Auto_Self_v3_24');
    }
  }

  &__row-header-item {
    display: flex;
    min-width: 0;

    @include media-sm() {
      flex-direction: column;
    }

    &--center {
      align-items: center;

      @include media-sm() {
        align-items: flex-start;
      }
    }
  }

  &__row-header-delivery {
    display: flex;
  }

  &__btn-buy {
    height: 32px;

    &:not(:hover) {
      color: #595959 !important;
      background: #eee;
    }
  }

  &__btn {
    padding: 0 15px;
    margin-right: 10px;
    font-size: rem(14);

    &:last-of-type {
      margin-right: 0;
    }

    @include media-xxs() {
      width: 100%;
      margin-right: 0;
      margin-bottom: 10px;
    }
  }

  &__btn-icon {
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }

  &__btn-group {
    display: flex;
    justify-content: space-between;
  }

  &__btn-group-col {
    display: flex;
    margin-right: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  &__row-body {
    display: flex;
    flex-direction: column;
  }

  &__row-body-content {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 15px;
  }

  &__row-filter {
    display: flex;
    width: 100%;

    @include media-lg() {
      flex-direction: column;
    }
  }

  &__row-body-system {
    padding-top: 9px;
    text-align: right;

    @include media-xs() {
      width: 100%;
    }
  }

  &__row-body-system-btn {
    margin-top: 15px;

    @include media-xxs() {
      width: 100%;
      margin-right: 0;
      margin-bottom: 10px;
    }
  }

  &__row-body-system-title {
    margin: 0;
    margin-bottom: 5px;
    font-size: rem(10);
    font-weight: 300;
    line-height: 14px;
    letter-spacing: 0.03em;
  }

  &__row-body-system-total {
    font-size: rem(16);
    line-height: 19px;
  }

  &__row-body-system-discount {
    justify-content: flex-end;
    margin-top: 5px;

    .app-title-box__title {
      font-size: rem(9);
    }

    .app-tooltip-answer {
      font-size: rem(9);
    }
  }

  &__input-control {
    margin: 0 10px 0 0;

    @include media-lg() {
      margin-right: 0;
      margin-bottom: 10px;
    }
  }

  &__density-col {
    max-width: 110px;

    @include media-md() {
      max-width: 90px;
    }
  }

  &__region-col {
    max-width: 55px;

    @include media-md() {
      max-width: 55px;
    }
  }

  &__change-col {
    max-width: 90px;
  }

  &__price-col {
    max-width: 110px;

    @include media-md() {
      max-width: 95px;
    }
  }
}

.offers-filter {
  &__label {
    position: relative;
    flex: 0 1 30%;
    padding: 10px 40px 2px 15px;
    margin: 0 10px 0 0;
    background: #fff url('/icons/ddm.svg') right center no-repeat;
    border: 1px solid $color-gray-1;

    &--input {
      padding-right: 80px;
      text-overflow: ellipsis;
      background: none;
    }
  }

  &__input {
    width: 100%;
    height: 24px;
    padding: 0;
    font-size: rem(14);
    font-weight: 300;
    line-height: 24px;
    text-overflow: ellipsis;
    border: none;
    outline: none;
  }

  &__title {
    position: relative;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    align-items: center;
    font-size: rem(11);
    font-weight: 300;
    color: $color-gray-8;
    text-overflow: ellipsis;
    white-space: nowrap;

    .tt {
      display: none;
    }

    &--info {
      display: inline-block;
      width: 14px;
      height: 14px;
      margin-left: 5px;
      font-size: rem(10);
      font-style: normal;
      line-height: 14px;
      color: $color-gray-6;
      text-align: center;
      cursor: pointer;
      border: 1px solid $color-gray-5;
      border-radius: 100%;

      &:hover + .tt {
        display: inline-block;
      }
    }
  }

  &__value {
    display: inline-block;
    width: 70%;
    overflow: hidden;
    font-size: rem(14);
    font-weight: 300;
    line-height: 24px;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
  }
}

@media (max-width: $lg) {
  .offers-filter {
    &__label {
      position: relative;
      flex: 0 0 100%;
      padding: 10px 40px 2px 15px;
      margin-bottom: 10px;
      background: #fff url('/icons/ddm.svg') right center no-repeat;
      border: 1px solid $color-gray-1;

      &--input {
        padding-right: 80px;
        text-overflow: ellipsis;
        background: none;
      }
    }

    &__input {
      width: 100%;
      height: 24px;
      padding: 0;
      font-size: rem(14);
      font-weight: 300;
      line-height: 24px;
      text-overflow: ellipsis;
      border: none;
      outline: none;
    }

    &__title {
      position: relative;
      display: -webkit-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -o-flex;
      display: flex;
      align-items: center;
      font-size: rem(11);
      font-weight: 300;
      color: $color-gray-8;
      text-overflow: ellipsis;
      white-space: nowrap;

      .tt {
        display: none;
      }

      &--info {
        display: inline-block;
        width: 14px;
        height: 14px;
        margin-left: 5px;
        font-size: rem(10);
        font-style: normal;
        line-height: 14px;
        color: $color-gray-6;
        text-align: center;
        cursor: pointer;
        border: 1px solid $color-gray-5;
        border-radius: 100%;

        &:hover + .tt {
          display: inline-block;
        }
      }
    }

    &__value {
      display: inline-block;
      width: 70%;
      overflow: hidden;
      font-size: rem(14);
      font-weight: 300;
      line-height: 24px;
      text-overflow: ellipsis;
      white-space: nowrap;
      cursor: pointer;
    }
  }
}
</style>
